import { 
    saveGroup,
    groupSelectList,
    groupDeleteGroup,
    labelSelectList,
    labelDeleteLabel,
    groupDeleteUserGroup,
    labelSaveLable,
    findCompanyPosition,
    findIndustry,
    selectByPhone,
    selectByUserPk
} from "../../../api/user"

import { 
    carListStatistics,
    findUserInfoList,
    carGroupStatistics,
    carLabelStatistics,
    consumeTypeStatisticsCarNumber,
    carPriceStatistic,
    carMileageStatistic,
    carFirstRegTimeStatistic,
    deleteCarGroup,
    carBrandStatistics,
    saveCarInfo,
    selectCarInfoByCarNo,
    getCarTypeBaseInfoByVinCode,
    getCarInfoByVinCode
} from "../../../api/car"


// 车辆管理头部数据统计
export const _carListStatistics = (options) => carListStatistics(options)

// 车辆管理列表
export const _findUserInfoList = (options) => findUserInfoList(options)

// 车辆群组统计
export const _carGroupStatistics = (options) => carGroupStatistics(options)

// 删除群组
export const _groupDeleteGroup = (options:any) => groupDeleteGroup(options)

// 删除客户群组
export const _groupDeleteUserGroup = (options:any) => groupDeleteUserGroup(options)

// 查询全部群组
export const _groupSelectList = (options:any) => groupSelectList(options)

// 保存编辑群组
export const _saveGroup = (options:any) => saveGroup(options)

// 查询全部标签
export const _labelSelectList = (options:any) => labelSelectList(options)

// 刪除标签
export const _labelDeleteLabel = (options:any) => labelDeleteLabel(options)

// 车辆标签统计
export const _carLabelStatistics = (options) => carLabelStatistics(options)

// 保存编辑标签
export const _labelSaveLable = (options:any) => labelSaveLable(options)

// 消费类型统计
export const _consumeTypeStatisticsCarNumber = (options) => consumeTypeStatisticsCarNumber(options)

// 车辆价格统计
export const _carPriceStatistic = (options) => carPriceStatistic(options)

// 行驶里程统计
export const _carMileageStatistic = (options) => carMileageStatistic(options)

// 行驶年限统计
export const _carFirstRegTimeStatistic = (options) => carFirstRegTimeStatistic(options)

// 删除车辆群组
export const _deleteCarGroup = (options:any) => deleteCarGroup(options)

// 删除车辆群组
export const _carBrandStatistics = () => carBrandStatistics()

// 查询职位数据列表
export const _findCompanyPosition = () => findCompanyPosition()

// 查询行业数据列表
export const _findIndustry = () => findIndustry()

// 保存车辆信息
export const _saveCarInfo = (options:any) => saveCarInfo(options)

// 按车牌查询车辆信息
export const _selectCarInfoByCarNo = (options:any) => selectCarInfoByCarNo(options)

// 手机号精确查询客户信息
export const _selectByPhone = (options:any) => selectByPhone(options)

// 客户PK查询客户信息
export const _selectByUserPk = (options:any) => selectByUserPk(options)

// VIN查询车型
export const _getCarTypeBaseInfoByVinCode = (options:any) => getCarTypeBaseInfoByVinCode(options)

// 根据VIN码查询车辆+客户基本信息
export const _getCarInfoByVinCode = (options:any) => getCarInfoByVinCode(options)